// extracted by mini-css-extract-plugin
export default {"issue-section-item":"IssueSectionList_issue-section-item__G4pkM","issueSectionItem":"IssueSectionList_issue-section-item__G4pkM"};